import { IMongoDocument } from "@/types"

export interface ILeaderProgressResponse {
  totalProgress: number
  userId: string
}

export interface IGetReferralsCountResponse {
  lvl1: number
  lvl2: number
  lvl3: number
  lvlN: number
}

export interface IRefreshPositionResponse {
  userId: string
  location: number
  rank: number
  position: number
}

export interface IUser extends IMongoDocument {
  hideUsername: boolean
  telegram: string
  name?: string
  username?: string
  avatar?: string
  email?: string
  referralCode?: string
  isPremium?: boolean
  invitedBy?: "string"
  location: number
  dogname: string
  wallets: { telegram?: string }
  referrer?: string
  isGameFinished: boolean
  availableInvites: number
  rank: number
  currentDiggingSpeed: number
  currentLuck: number
  currentStamina: number
  currentEndurance: number
  currentIntuition: number
  currentCraftRunePriceBonus: number
  currentCraftToolPriceBonus: number
  currentCraftRuneSuccessBonus: number
  claimRefBonusCoefficients: {
    star: {
      level1: number
      level2: number
      level3: number
    }
    gold: {
      level1: number
      level2: number
      level3: number
    }
  }
  positionInLeaders: number
  role?: "user" | "moderator" | "admin"
  isSoundMute: boolean
  hasVipPass?: boolean
}

export type IUserLeaderboardShort = {
  _id: string
  hideUsername: false
  username: string
  avatar: string
  dogname: string
  rank: number
  currentDiggingSpeed: number
  currentLuck: number
  currentEndurance: number
  location: number
}

export type IUserStats = {
  currentDiggingSpeed: number
  currentLuck: number
  currentStamina: number
  currentEndurance: number
  currentIntuition: number
}

export interface IReferral {
  ownerId: string
  invitedUserId: string
  totalEarned: {
    star: number
    gold: number
    bones: number
  }
  availableToClaim: {
    star: number
    gold: number
    bones: number
  }
}

export interface IUserStakingBonus {
  _id: "68248131c04da7d3b9d934e8"
  labrInStaking: 1000
  month: 12
  bonusPercentage: 1
  __v: 0
}

export const USER_UPGRADE_TYPE = {
  LUCK: "luck",
  STAMINA: "stamina",
  SPEED: "speed"
} as const
export type IUserUpgradeType =
  (typeof USER_UPGRADE_TYPE)[keyof typeof USER_UPGRADE_TYPE]

export interface IUserUpgrade extends IMongoDocument {
  userId: string
  type: IUserUpgradeType
  goldLevel: number
  bonesLevel: number
}

export interface IUserShortClan {
  _id: string
  abbreviation: string
}

export interface IUserAchievements extends IMongoDocument {
  userId: string
  explorer: number
  fixer: number
  merchantLicense: number
  miner: number
}

export const TOOL_TYPE = {
  WOOD: "wood",
  STEEL: "steel",
  TITANIUM: "titanium",
  DIAMOND: "diamond"
} as const
export type IToolType = (typeof TOOL_TYPE)[keyof typeof TOOL_TYPE]

export interface ITool extends IMongoDocument {
  ownerId: string
  type: IToolType
  description: string
  name: string
  imgSrc: string
  isActive: boolean
  breedCharges: number
  runeSlots: number
  luckBonus: number
  speedBonus: number
  enduranceBonus: number
  ableToBreedAt: string
  fakeId: string | null
  isRuneSlotsEmpty: boolean
  isGenesis: boolean
}

export const RUNE_TYPE = {
  SPEED: "speed",
  LUCK: "luck",
  STAMINA: "stamina"
} as const
export type IRuneType = (typeof RUNE_TYPE)[keyof typeof RUNE_TYPE]

export interface IRune extends IMongoDocument {
  level: number
  coefficientBonus: number
  integerBonus: number
  type: IRuneType
  imgSrc: string
  priceToUse: any
  ownerId: string
  toolId: string
}

export interface IUserActiveTool {
  activeTool: ITool
  runesInActiveTool: IRune[]
}

export interface IUserLeaderboardData {
  progress: number
  stakingBonus?: IUserStakingBonus
  luckUpgrade: IUserUpgrade
  staminaUpgrade: IUserUpgrade
  speedUpgrade: IUserUpgrade
  shortClan: IUserShortClan
  activeTool: IUserActiveTool
  achievements: IUserAchievements
  position: number
  location: number
}
